import SEO from "../../components/SEO";
import NewsTicker from "../../components/NewsTicker";

// All published blog posts — one canonical guide per topic (retired duplicate
// slugs redirect to these via BlogSlugRedirect in App.tsx). Each entry links
// with a plain <a href> so crawlers discover every post from /blog; the URL is
// relative so the same page works on the preview and staging hosts too.
const POSTS = [
  {
    slug: "best-indian-restaurants-dfw",
    title: "Best Indian Restaurants in DFW: North & South Indian Dining Guide",
    description:
      "Find the best Indian restaurants in Dallas–Fort Worth. Expert picks for North Indian, South Indian, biryani, and fusion dining in Frisco, Plano, Irving, Dallas & beyond.",
  },
  {
    slug: "best-indian-grocery-stores-dfw",
    title: "Best Indian Grocery Stores in Dallas–Fort Worth | Find Fresh Spices & Authentic Products",
    description:
      "Discover the best Indian grocery stores in Dallas–Fort Worth for fresh spices, authentic products, and specialty South Asian ingredients.",
  },
  {
    slug: "upcoming-desi-events-dfw",
    title: "Upcoming Indian & Desi Events in Dallas–Fort Worth | Concerts, Festivals & Celebrations",
    description:
      "Upcoming Indian and desi events across Dallas–Fort Worth — concerts, festivals, and celebrations for the South Asian community.",
  },
  {
    slug: "ecommerce-for-dallas-desi-businesses",
    title: "Ecommerce for Dallas Desi Businesses: How Local Shops Can Launch an Online Store",
    description:
      "What ecommerce means, which ecommerce platforms to choose, and how Dallas–Fort Worth Indian restaurants, grocers, and boutiques can build a real ecommerce business.",
  },
  {
    slug: "how-to-start-ecommerce-business",
    title: "How to Start an Ecommerce Business in 2025: The Complete Guide for Desi Entrepreneurs",
    description:
      "Step-by-step guide to launching your ecommerce business in 2025, with specific advice for South Asian entrepreneurs in Dallas–Fort Worth.",
  },
];

export default function BlogIndex() {
  return (
    <div className="min-h-screen">
      <SEO
        title="Dallas Desi Blog | Guides & Desi Community News | Dallas Desi Scoop"
        description="Read the Dallas Desi Scoop blog — guides to the best Indian restaurants and grocery stores in DFW, upcoming desi events, concerts, festivals, and ecommerce tips for South Asian businesses in Dallas–Fort Worth."
        canonical="/blog"
        jsonLd={[
          {
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://dallasdesiscoop.com/" },
              { "@type": "ListItem", position: 2, name: "Blog", item: "https://dallasdesiscoop.com/blog" },
            ],
          },
          {
            "@type": "Blog",
            "@id": "https://dallasdesiscoop.com/blog",
            name: "Dallas Desi Scoop Blog",
            url: "https://dallasdesiscoop.com/blog",
            publisher: { "@id": "https://dallasdesiscoop.com/#organization" },
            blogPost: POSTS.map((p) => ({
              "@type": "BlogPosting",
              headline: p.title,
              url: `https://dallasdesiscoop.com/blog/${p.slug}`,
            })),
          },
        ]}
      />
      <NewsTicker />

      <div className="max-w-[880px] w-[calc(100%-32px)] mx-auto px-4 py-12 md:py-14">
        <header className="mb-10">
          <h1
            className="text-3xl md:text-4xl font-bold text-[#082f6d] mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            DFW Desi Guides, Restaurants, Events &amp; Community
          </h1>
          <p className="text-gray-600 text-[15px] md:text-base leading-relaxed">
            Dallas Desi Scoop publishes guides and information about Indian, Pakistani, Desi,
            South Asian, Mediterranean and Middle Eastern restaurants, grocery stores, events,
            shopping, businesses and community activities in the Dallas–Fort Worth area.
          </p>
        </header>

        <ul className="space-y-5">
          {POSTS.map((post) => (
            <li
              key={post.slug}
              className="border border-gray-200 rounded-lg p-5 hover:border-[#f59e0b] transition-colors"
            >
              <a
                href={`/blog/${post.slug}`}
                className="text-lg md:text-xl font-semibold text-[#082f6d] hover:text-[#f59e0b] leading-snug"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {post.title}
              </a>
              <p className="text-gray-600 text-[14px] md:text-[15px] leading-relaxed mt-2">
                {post.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
